const MIME_EXACT_KIND_MAP = {
  "application/pdf": "pdf",
  "text/html": "code",
};

const MIME_SUBSTRING_KIND_RULES = [
  { matches: ["word", "msword"], kind: "word" },
  { matches: ["excel", "spreadsheet"], kind: "excel" },
  { matches: ["powerpoint", "presentation"], kind: "powerpoint" },
  { matches: ["code"], kind: "code" },
];

const MIME_PREFIX_KIND_MAP = {
  "text/": "text",
  "image/": "image",
  "video/": "video",
  "audio/": "audio",
};

export const DOCUMENT_EXTENSION_KIND_MAP = {
  pdf: "pdf",
  doc: "word",
  docx: "word",
  xls: "excel",
  xlsx: "excel",
  ppt: "powerpoint",
  pptx: "powerpoint",
  txt: "text",
  odt: "text",
  rtf: "text",
};

const getUrlExtension = (url) => {
  const cleanUrl = url.split("?")[0].split("#")[0];
  return cleanUrl.split(".").pop()?.toLowerCase();
};

export const getMimeIconKind = (mimetype, stackType) => {
  if (stackType === "news") return "news";
  if (!mimetype) return "file";

  if (MIME_EXACT_KIND_MAP[mimetype]) {
    return MIME_EXACT_KIND_MAP[mimetype];
  }

  const substringMatch = MIME_SUBSTRING_KIND_RULES.find(({ matches }) =>
    matches.some((value) => mimetype.includes(value)),
  );
  if (substringMatch) return substringMatch.kind;

  const prefixMatch = Object.entries(MIME_PREFIX_KIND_MAP).find(([prefix]) =>
    mimetype.startsWith(prefix),
  );
  if (prefixMatch) return prefixMatch[1];

  return "file";
};

// Never the raw `url` (ADR-0072): it is the server's storage location and
// rolodex rows don't carry it. A read response names the file (`filename`);
// every response exposes the address to read (`mediaUrl`).
export const getDocumentExtension = (item) => {
  const address = item?.filename || item?.mediaUrl || item?.src || "";
  const fileName = item?.name || item?.fileName || "";
  const fileType = item?.fileType || item?.type;

  return (
    fileType?.toLowerCase() ||
    (address && getUrlExtension(address)) ||
    fileName.split(".").pop()?.toLowerCase()
  );
};

const DOCUMENT_KINDS = new Set(Object.values(DOCUMENT_EXTENSION_KIND_MAP));

export const getDocumentIconKind = (item) => {
  const byExtension = DOCUMENT_EXTENSION_KIND_MAP[getDocumentExtension(item)];
  if (byExtension) return byExtension;
  const byMimetype = getMimeIconKind(item?.mimetype);
  return DOCUMENT_KINDS.has(byMimetype) ? byMimetype : "text";
};
